import React, { useEffect } from 'react';

const MicroFrontend = ({ name, host, history, mfeProps }) => {
  useEffect(() => {
    const scriptId = `micro-frontend-script-${name}`;

    const renderMicroFrontend = () => {
      if (window[`render${name}`])
        window[`render${name}`](`${name}-container`, history, mfeProps);
    };

    if (document.getElementById(scriptId)) {
      renderMicroFrontend();
      return;
    }

    try {
      fetch(`${host}/asset-manifest.json`)
        .then((res) => res.json())
        .then((manifest) => {
          const script = document.createElement('script');
          script.id = scriptId;
          script.crossOrigin = '';
          script.src = `${host}${manifest.files['main.js']}`;
          script.async = true;
          script.onload = () => {
            renderMicroFrontend();
          };
          document.head.appendChild(script);

          console.log(manifest.files);

          if (manifest?.files?.['main.css']) {
            console.log(`${host}${manifest.files['main.css']}`);

            const cssLink = document.createElement('link');
            cssLink.rel = 'stylesheet';
            cssLink.crossOrigin = '';
            cssLink.href = `${host}${manifest.files['main.css']}`;
            script.async = true;
            document.head.appendChild(cssLink);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    }

    // Setup observer to watch for appointment button
    const observer = new MutationObserver(() => {
      const injectLiineSDK = () => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.defer = true;
        script.src = process.env.REACT_APP_LINE_SDK_REMOTE;
        script.id = 'liine-sdk-script';
        document.body.appendChild(script);
      };
      const appointmentButton = document.getElementById('appointment-button');
      if (appointmentButton && !document.getElementById('liine-sdk-script')) {
        injectLiineSDK();
        observer.disconnect(); // Stop observing once SDK is injected
      }
    });

    // Start observing the document with the configured parameters
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
      window[`unmount${name}`] && window[`unmount${name}`](`${name}-container`);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <main id={`${name}-container`} />;
};

MicroFrontend.defaultProps = {
  document,
  window,
};

export default MicroFrontend;
